import { MapGeoJSONFeature } from 'maplibre-gl';
import React from 'react';
import './AttributeTable.css';
import AttributeValue from '../attributeValue/AttributeValue';

interface AttributeTableProps {
    attributes: {
        [key: string]: MapGeoJSONFeature[];
    } | undefined;
}

// 属性情報 テーブル表示
const AttributeTable: React.FC<AttributeTableProps> = ({ attributes }) => {

    if(!attributes) { return null; }

    return (
        <>{
            Object.keys(attributes).map((key) => {
                const feature = attributes[key];
                return (
                    <div key={key} className='attribute-container'>
                        <h5>{`⚫︎ ${key}`}</h5>
                        {
                            feature.map((feature: MapGeoJSONFeature, key: number) => {
                                return (
                                    <div key={key} className='attributes-wrapper'>
                                        {
                                            feature.properties &&
                                            Object.keys(feature.properties).map((propKey) => {
                                                return (
                                                    <div key={propKey} className='attribute-row'>
                                                        <div className='key'>
                                                            <p>{propKey}</p>
                                                        </div>
                                                        <div className='value'>
                                                            <AttributeValue 
                                                                itemKey={propKey} 
                                                                value={feature.properties[propKey]} 
                                                                small
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                );
                            })
                        }
                    </div>
                )
            })
        }</>
    );
};

export default AttributeTable;
